import { Button, Card, CardContent, CardFooter } from "@repo/ui";
import { ExternalLink, Github } from "lucide-react";

import { Footer } from "@/components/footer";
import { Nav } from "@/components/nav";

const projects = [
  {
    title: "Purple Nebula UI",
    desc: "A minimal, accessible component library in dark mode.",
    img: "https://images.pexels.com/photos/7130555/pexels-photo-7130555.jpeg?auto=compress&cs=tinysrgb&w=1200",
    demo: "#",
    code: "#",
  },
  {
    title: "Velocity CMS",
    desc: "Headless CMS built with Hono, Drizzle, and Vite.",
    img: "https://images.pexels.com/photos/7130497/pexels-photo-7130497.jpeg?auto=compress&cs=tinysrgb&w=1200",
    demo: "#",
    code: "#",
  },
  {
    title: "Pulse Analytics",
    desc: "Lightweight dashboard with charts and real-time updates.",
    img: "https://images.pexels.com/photos/3861964/pexels-photo-3861964.jpeg?auto=compress&cs=tinysrgb&w=1200",
    demo: "#",
    code: "#",
  },
];

export function Projects() {
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <section className="mx-auto max-w-6xl px-4 md:px-6 py-12">
        <h1 className="text-3xl md:text-4xl font-semibold mb-6">Projects</h1>
        <p className="text-foreground/70 mb-8">A selection of recent work and experiments.</p>
        <div className="grid md:grid-cols-3 gap-6">
          {projects.map((p) => (
            <Card key={p.title} className="overflow-hidden bg-card/60">
              <img src={p.img} alt="Project image" className="h-40 w-full object-cover" />
              <CardContent className="p-6">
                <h3 className="text-xl font-semibold">{p.title}</h3>
                <p className="text-foreground/70 mt-2">{p.desc}</p>
              </CardContent>
              <CardFooter className="p-6 pt-0 flex gap-3">
                <a href={p.demo} target="_blank" rel="noreferrer">
                  <Button variant="secondary" className="h-9">
                    <ExternalLink className="size-4 mr-2" />
                    Live
                  </Button>
                </a>
                <a href={p.code} target="_blank" rel="noreferrer">
                  <Button variant="outline" className="h-9">
                    <Github className="size-4 mr-2" />
                    Code
                  </Button>
                </a>
              </CardFooter>
            </Card>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
